
export default {
    namespaced: true,
    state: () => ({
      notifications: [],
      threads: []
    }),
    mutations: {
      setNotifications(state, data){
        state.notifications = data;
      },
      setThreads(state, data){
        state.threads = data;
      },
      addNotification(state, data){
        state.notifications.push(data)
      }
    },
    actions: {
      setNotifications({commit}, payload){
        commit("setNotifications", payload)
      },
      setThreads({commit}, payload){
        commit("setThreads", payload)
      },
      addNotification({commit}, payload){
        commit("addNotification", payload)
      }
    },
    getters: {
      notifications(state){
        return state.notifications || null;
      },
      threads(state){
        return state.threads || null;
      },
    }
  }